import styled from 'styled-components';

interface HeaderProps {
  whiteBackground: boolean;
}

export const Container = styled.header<HeaderProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 3;
  left: 0;

  width: 100%;
  height: 100px;

  padding: 15px 100px;

  margin-top: ${({ whiteBackground }) => (whiteBackground ? '0px' : '20px')};
  position: ${({ whiteBackground }) =>
    whiteBackground ? 'fixed' : 'absolute'};
  background-color: ${({ whiteBackground }) =>
    whiteBackground ? '#fff' : 'rgba(0, 0, 0, 0)'};

  @media only screen and (max-width: 1000px) {
    padding: 15px 20px;
    height: 60px;
  }
`;

export const Logo = styled.div<HeaderProps>`
  svg {
    fill: ${({ whiteBackground }) => (whiteBackground ? '#199EC6' : '#fff')};

    width: 50px;
  }

  @media only screen and (max-width: 1000px) {
    svg {
      width: ${({ whiteBackground }) => (whiteBackground ? '35px' : '50px')};
    }
  }
`;

export const Navigator = styled.nav<HeaderProps>`
  display: flex;

  li {
    list-style: none;

    button,
    a {
      background: none;
      border: none;
      text-decoration: none;

      font-weight: 800;
      font-size: 12px;
      text-transform: uppercase;

      padding: 0px 50px;
      color: ${({ whiteBackground }) => (whiteBackground ? '#199EC6' : '#fff')};

      :hover {
        color: #386882;
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    display: none;
  }
`;

export const MenuButton = styled.button<HeaderProps>`
  display: none;
  background: none;
  border-width: 0px;

  @media only screen and (max-width: 1000px) {
    display: flex;

    svg {
      color: ${({ whiteBackground }) => (whiteBackground ? '#199EC6' : '#fff')};
      font-size: ${({ whiteBackground }) =>
        whiteBackground ? '22px' : '30px'};
      min-width: 10px;
    }
  }
`;

interface SideMenuContainerProps {
  menuOpen: boolean;
}

export const SideMenuContainer = styled.div<SideMenuContainerProps>`
  height: 100%;
  width: ${({ menuOpen }) => (menuOpen ? '100%' : '0%')};
  position: fixed;
  z-index: 4;
  top: 0;
  right: 0;
  background-color: #fff;
  overflow-x: hidden;
  padding-top: 60px;
  transition: width 0.2s;

  display: flex;
  flex: 1;
  flex-direction: column;

  li {
    list-style: none;
    margin: 0 auto;

    button,
    a {
      background: none;
      border: none;
      text-decoration: none;

      font-weight: 800;
      font-size: 24px;
      text-transform: uppercase;
      white-space: nowrap;

      color: #199ec6;

      :hover {
        color: #386882;
      }
    }

    & + li {
      margin-top: 20px;
    }
  }
`;
